import {Box, styled, Subtitle2, UploadOutlinedIcon} from '../../../ui-library';

export const ContainerBox = styled(Box)`
    width: 100%;
    height: 112px;
    border: 1px dashed ${({ theme }) => theme.palette.grey['400']};
    border-radius: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 14px;
`;


export const UploadOutlinedIconSmall = styled(UploadOutlinedIcon)`
    color: ${({ theme }) => theme.palette.grey['400']};
    width: 24px;
    height: 24px;
`;

export const SubtitleUpload = styled(Subtitle2)`
    ${({ theme }) => theme.typography.subtitle2};
    color: ${({ theme }) => theme.palette.grey['500']};
`;
export const A = styled(Subtitle2)`
    ${({ theme }) => theme.typography.subtitle2};
    color: ${({ theme }) => theme.palette.primary.main};
    cursor: pointer;
`;

export const ContainerUploadTitleBox = styled(Box)`
    display: flex;
    flex-direction: row;
    gap: 6px;
`;
